// For local setup -- Local Host
const local = {
    apiUrl: process.env.REACT_APP_LOCAL_API_URL,
    encryptionkey: process.env.REACT_APP_LOCAL_ENCRYPTION_KEY || "",
    PORT: process.env.REACT_APP_LOCAL_PORT,
    API_BASEURL: process.env.REACT_APP_LOCAL_API_BASEURL,
    SOCKET_URL: process.env.REACT_APP_LOCAL_SOCKET_URL,

    firsebase : {
      apiKey: process.env.REACT_APP_LOCAL_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_LOCAL_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_LOCAL_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_LOCAL_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_LOCAL_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_LOCAL_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_LOCAL_FIREBASE_MEASUREMENT_ID,
    }
  };
// For development server
    const dev = {
        apiUrl: process.env.REACT_APP_DEV_API_URL,
        encryptionkey: process.env.REACT_APP_DEV_ENCRYPTION_KEY || "",
        PORT: process.env.REACT_APP_DEV_PORT,
        API_BASEURL: process.env.REACT_APP_DEV_API_BASEURL,
        SOCKET_URL: process.env.REACT_APP_DEV_SOCKET_URL,

        firsebase : {
          apiKey: process.env.REACT_APP_DEV_FIREBASE_API_KEY,
          authDomain: process.env.REACT_APP_DEV_FIREBASE_AUTH_DOMAIN,
          projectId: process.env.REACT_APP_DEV_FIREBASE_PROJECT_ID,
          storageBucket: process.env.REACT_APP_DEV_FIREBASE_STORAGE_BUCKET,
          messagingSenderId: process.env.REACT_APP_DEV_FIREBASE_MESSAGING_SENDER_ID,
          appId: process.env.REACT_APP_DEV_FIREBASE_APP_ID,
          measurementId: process.env.REACT_APP_DEV_FIREBASE_MEASUREMENT_ID,
        }

      };
  
  // For Staging server
  const staging = {
    apiUrl: process.env.REACT_APP_STAGING_API_URL,
    encryptionkey: process.env.REACT_APP_STAGING_ENCRYPTION_KEY || "",
    PORT: process.env.REACT_APP_STAGING_PORT,
    API_BASEURL: process.env.REACT_APP_STAGING_API_BASEURL,
    SOCKET_URL: process.env.REACT_APP_STAGING_SOCKET_URL,

    firsebase : {
      apiKey: process.env.REACT_APP_STAGING_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_STAGING_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_STAGING_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_STAGING_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_STAGING_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_STAGING_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_STAGING_FIREBASE_MEASUREMENT_ID,
    }
  };

    // For PRODUCTION server
    const production = {
      apiUrl: process.env.REACT_APP_PRODUCTION_API_URL,
      encryptionkey: process.env.REACT_APP_PRODUCTION_ENCRYPTION_KEY || "",
      PORT: process.env.REACT_APP_PRODUCTION_PORT,
      API_BASEURL: process.env.REACT_APP_PRODUCTION_API_BASEURL,
      SOCKET_URL: process.env.REACT_APP_PRODUCTION_SOCKET_URL,

      firsebase : {
        apiKey: process.env.REACT_APP_PRODUCTION_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_PRODUCTION_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_PRODUCTION_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_PRODUCTION_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_PRODUCTION_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_PRODUCTION_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_PRODUCTION_FIREBASE_MEASUREMENT_ID,
      }
    };
  
  if (process.env.REACT_APP_ENV === "local") module.exports = local;
  else if (process.env.REACT_APP_ENV === "dev") module.exports = dev;
  else if (process.env.REACT_APP_ENV === "staging") module.exports = staging;
  else if (process.env.REACT_APP_ENV === "prod") module.exports = production;
  else module.exports = local;
  
  


// //For local setup -- Local Host
// const local = {
//     apiUrl: "http://localhost:",
//     encryptionkey: "",
//     PORT: "9277",
//     API_BASEURL: "http://localhost:9277/api/v1",
//     SOCKET_URL: "http://localhost:9277",
//     // Frontend_Url: "http://localhost:3000",
// };
 
// // For Staging server --
// // http://44.211.113.36:9281/
// const staging = {
//     apiUrl: "https://meanstack.smartdatainc.com:",
//     encryptionkey: "",
//     // PORT: "9277/api/v1",
//     PORT: "9277",
//     API_BASEURL: "https://meanstack.smartdatainc.com:9277",
//     SOCKET_URL: "https://meanstack.smartdatainc.com:9277",

 
//     // SOCKET_URL: "wss://ss.stagingsdei.com:9186", // Use 'wss' protocol for WebSocket
 
//     // Frontend_Url: "https://ss.stagingsdei.com:9161", // Update to the correct frontend URL
//   };
  
// // 54.201.160.69:9162
// // const staging = {
// //   // apiUrl: "http://54.190.192.105:",
// //   // encryptionkey: "",
// //   // PORT: '9121/api/v1',
// //   // API_BASEURL: "http://54.190.192.105:9121",
// //   // SOCKET_URL: "ws://54.190.192.105:9121"
// // };
 
// //For staging server port KEY can not be remove its using in application
 
// const dev = {
//     // apiUrl: "http://190.92.159.196:",
//     // encryptionkey: "",
//     // PORT: '9121/api/v1',
//     // API_BASEURL: "http://190.92.159.196:9121",
//     // SOCKET_URL: "ws://190.92.159.196:9121"
// };
 
// if (process.env.REACT_APP_ENV === "local") module.exports = local;
// else if (process.env.REACT_APP_ENV === "dev") module.exports = dev;
// else if (process.env.REACT_APP_ENV === "staging") module.exports = staging;
// // module.exports = staging;
// // else module.exports = dev; rebuild
// module.exports = local;
